import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";
import { useQuestion } from "../../globals/QuestionContext";
import { useSetHtml } from "../../globals/HtmlContext";

export default function RestartButton() {
  //   const html = useHtml();
  //   const user = useUser();
  //   const setUser = useSetUser();
  //   const assignment = useAssignment();
  const setHtml = useSetHtml();
  const question = useQuestion();
  //   const question = useQuestion();
  //   // let requirements = question?.requirements;
  //   let answer = question.answer;

  //   const [dialogTitle, setDialogTitle] = React.useState("Correct!");

  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleYes = () => {
    setHtml(question.code);
    setOpen(false);
  };

  return (
    <>
      <Button
        color="secondary"
        variant="contained"
        onClick={handleOpen}
        sx={{ marginRight: "0.5rem" }}
      >
        Start Over
      </Button>
      <Dialog
        open={open}
        TransitionComponent={Slide}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Restart Question</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to reset this assignment?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="secondary" onClick={handleYes}>
            Yes
          </Button>
          <Button color="primary" onClick={handleClose}>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
